import { StockTypesEnum } from "@gtpl/shared-models/common-models"

export class StockOutTypeReq{
    stockOutType:StockTypesEnum
    plantId: number

    constructor(stockOutType:StockTypesEnum,plantId: number){
        this.stockOutType = stockOutType
        this.plantId = plantId
    }

}